export default __webpack_public_path__ + "static/media/step-3@3x.585d0d41.png";